import React from "react";
import { Box } from "@mui/material";

import ListView from "../components/listView";

function BoardListController({
  board,
  cards,
  isCardsLoading,
  isMilestoneView,
  workflowId,
  setLoading,
  allCardsByBoard,
}) {
  if (!workflowId || !board) {
    return null;
  }

  return (
    <Box mt={isMilestoneView ? 3 : 7.5}>
      <ListView
        allCardsByBoard={allCardsByBoard}
        boardName={board}
        cards={cards}
        isLoading={isCardsLoading}
        setLoading={() => setLoading(false)}
        workflowId={workflowId}
      />
    </Box>
  );
}

export default BoardListController;
